import React from 'react';
import ActiveGameScore from './Scoreboard/ActiveGameScore';
import './ActiveGameScorePage.scss';

interface IScoreboardPageProps {
}

export const ActiveGameScorePage: React.FC<IScoreboardPageProps> = () => {

  return (
    <div className="scoreboard-page">
      <ActiveGameScore/>
    </div>
  );
}
ActiveGameScorePage.displayName = "ActiveGameScorePage";

